import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { LivemodeFilterValidationSchema } from '../shared/livemode';

export const GetPaymentInputValidationSchema = z.object({
  paymentId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the payment to retrieve. Use `list_payments` first if you need to discover the payment ID by email, name, customer, page, product, or date range. Bookings for event pages have their own IDs and are not retrievable here.',
  }),
  livemode: LivemodeFilterValidationSchema,
});
